var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97922 17.0971L2.97933 17.0969C3.51984 16.5564 3.82353 15.8233 3.82353 15.0588V8.47059C3.82353 6.48927 4.61061 4.58909 6.01161 3.18809C7.41261 1.78709 9.3128 1 11.2941 1C13.2754 1 15.1756 1.78708 16.5766 3.18808C17.9776 4.58908 18.7647 6.48927 18.7647 8.47059V15.0588C18.7647 15.8234 19.0685 16.5564 19.6089 17.0969L19.609 17.097C19.9526 17.4406 20.3741 17.6885 20.832 17.8235H1.75622C2.21414 17.6885 2.63561 17.4406 2.97922 17.0971Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5882 20.706C14.5882 21.1386 14.503 21.5669 14.3375 21.9666C14.1719 22.3662 13.9293 22.7294 13.6234 23.0353C13.3175 23.3412 12.9544 23.5838 12.5547 23.7493C12.1551 23.9149 11.7267 24.0001 11.2941 24.0001C10.8615 24.0001 10.4332 23.9149 10.0335 23.7493C9.63385 23.5838 9.27071 23.3412 8.96482 23.0353C8.65894 22.7294 8.41629 22.3662 8.25075 21.9666C8.0852 21.5669 8 21.1386 8 20.706L11.2941 20.706H14.5882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notifIcon.0ce87c9bde8a56d78dff9e0ec98261df.svg";
export { ForwardRef as ReactComponent };